function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20013992_47880)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 14.781C7.307 14.74 6.705 14.295 6.49 13.651C5.95 12.032 6.135 12.283 4.704 11.289C4.254 10.977 4 10.481 4 9.968C4 9.798 4.027 9.627 4.085 9.459C4.638 7.848 4.639 8.159 4.085 6.539C4.027 6.373 4 6.201 4 6.032C4 5.518 4.254 5.023 4.704 4.71C6.134 3.718 5.949 3.969 6.49 2.347C6.715 1.672 7.368 1.216 8.105 1.216H8.11C9.875 1.222 9.561 1.325 10.999 0.313C11.297 0.104 11.648 0 12 0C12.352 0 12.703 0.104 13.001 0.313C14.429 1.317 14.121 1.222 15.89 1.216H15.895C16.632 1.216 17.285 1.672 17.511 2.347C18.051 3.966 17.862 3.715 19.297 4.71C19.746 5.022 20 5.518 20 6.031C20 6.2 19.974 6.373 19.915 6.539C19.363 8.151 19.361 7.841 19.915 9.459C19.974 9.627 20 9.799 20 9.968C20 10.481 19.746 10.977 19.297 11.289C17.862 12.285 18.051 12.034 17.511 13.651C17.295 14.294 16.694 14.74 16 14.781V24L12.042 21L8 24V14.781ZM17.714 8C17.714 4.845 15.157 2.286 12 2.286C8.845 2.286 6.286 4.845 6.286 8C6.286 11.155 8.845 13.714 12 13.714C15.157 13.714 17.714 11.155 17.714 8ZM12 4C9.795 4 8 5.794 8 8C8 10.206 9.795 12 12 12C14.206 12 16 10.206 16 8C16 5.794 14.206 4 12 4Z",
  fill: "url(#paint0_linear_20013992_47880)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4C9.795 4 8 5.794 8 8C8 10.206 9.795 12 12 12C14.206 12 16 10.206 16 8C16 5.794 14.206 4 12 4Z",
  fill: "url(#paint1_linear_20013992_47880)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20013992_47880",
  x1: 14.5,
  y1: 21,
  x2: -1.87816,
  y2: 6.76149,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F20058"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71875,
  stopColor: "#FF75A7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF498B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_20013992_47880",
  x1: 16,
  y1: 13.1667,
  x2: 8,
  y2: 4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF659C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20013992_47880"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.527026ea170eaac5bb652db478142e94.svg";
export { ForwardRef as ReactComponent };